import { onLocaleChange } from './index';

/** Subscribe to locale changes; returns an unsubscribe function. */
export function bindLocaleRefresh(refresh: () => void): () => void {
  return onLocaleChange(refresh);
}
